import {
	sliderListing,
	sliderJflix,
	sliderThehousehub,
	sliderPurplehub,
	sliderRPS,
	stCharbelPrinting,
	limitedArt,
	sliderBasket,
	sliderBed,
	sliderChairSingle,
	sliderChairLeather,
	sliderChairDouble,
	sliderLight,
  sliderDiningTable,
  hutchDesk,
  sliderChildMirror,
  sliderPowderRoom,
	sliderChairBlue,
	sliderNinjaKnife,
	sliderPurplehubSm,
	sliderJflixSm,
	sliderThehousehubSm,
	sliderListingSm,
	sliderRPSSm,
	stCharbelPrintingSm,	
} from "../../public/images/index.js";

export const sliderDataWeb = [
	{
		title: "Limited Art",
		description: "This website I created using MERN Stack with Redux for state management, JWT for authentication, plain CSS for styling.",
		backgroundImage: limitedArt,
		imgAlt: "Limited Art",
		link: "https://limitedart.junfel.com",
		github: "https://github.com/vjunfel/",
		category: "web development",
		id: "limited-art",
	},
	{
		title: "Purplehub",
		description: "This is a pastry website I created from scratch using Figma, NextJS, TypeScript, TailwindCSS and deploy to vercel.",
		backgroundImage: sliderPurplehub,
		backgroundImageSm: sliderPurplehubSm,
		imgAlt: "Purplehub",
		link: "https://purplehub.vercel.app",
		github: "https://github.com/vjunfel/purplehub-next",
		category: "web development",
		id: "purplehub",
	},
		{
		title: "St Charbel Printing",
		description: "Local printing business website located in consolacion, cebu. I created this website using React, TypeScript, TailwindCSS and deploy to vercel.",
		backgroundImage: stCharbelPrinting,
		backgroundImageSm: stCharbelPrintingSm,
		imgAlt: "St Charbel Printing",
		link: "https://stcharbelprinting.junfel.com",
		github: "https://github.com/vjunfel/stcharbelprenting-react",
		category: "web development",
		id: "st-charbel-printing",
	},
	{
		title: "J-Flix",
		description:
			"J-Flix is a Movie and TV Shows list where you can find the latest movies, it's rating, description and other details. This project allows me to enhance my skills in API integration.",
		backgroundImage: sliderJflix,
		backgroundImageSm: sliderJflixSm,
		imgAlt: "J-Flix",
		link: "https://j-flix.netlify.app",
		github: "https://github.com/vjunfel/J-Flix-App",
		category: "web development",
		id: "j-flix",
	},
	{
		title: "The househub",
		description: "This application emits some functionality of Airbnb website.",
		backgroundImage: sliderThehousehub,
		backgroundImageSm: sliderThehousehubSm,
		imgAlt: "thehousehub",
		link: "https://thehousehub.vercel.app",
		github: "https://github.com/vjunfel",
		category: "web development",
		id: "the-househub",
	},
	{
		title: "Listing App",
		description:
			"A todo app, one of my practice project to enhance my skills with dark and light mode feature. I created this using HTML, CSS and Javascript and deployed in Netlify.app.",
		backgroundImage: sliderListing,
		backgroundImageSm: sliderListingSm,
		imgAlt: "Todo App",
		link: "https://junfel-listing.netlify.app",
		github: "https://github.com/vjunfel/listing-app",
		category: "web development",
		id: "listing-app",
	},
	// {
	// 	title: "Rock-Paper-Scissors",
	// 	description: "This simple rock, paper and scissors game was created using only JavaScript together with HTML and CSS. This is one of my early project during my learning in a JavaScript language. It helped me enhance my understanding in JavaScript language as will as HTML and CSS without using any framework and it's a fun game to play with.",
	// 	backgroundImage: sliderRPS,
	// 	backgroundImageSm: sliderRPSSm,
	// 	imgAlt: "Rock-Paper-Scissors",
	// 	link: "https://rps-junfel.vercel.app/",
	// 	github: "https://github.com/vjunfel/rock-paper-scissors",
	// 	category: "web development",
	// 	id: "rock-paper-scissors",
	// },
];

export const sliderData3D = [
	{
		title: "Wicker Basket",
		description: "These decorative storage baskets have a fresh, attractive look that works in any room.",
		backgroundImage: sliderBasket,
		imgAlt: "basket",
	},
	{
		title: "Bed",
		description: "Clean-lined and thoughtfully padded, this upholstered platform bed is your first-class ticket to a relaxing night's sleep. It has a solid and engineered wood frame that's surrounded by a neutral-toned fabric.",
		backgroundImage: sliderBed,
		imgAlt: "bed",
	},
	{
		title: "Classic Chair",
		description: "This classic and traditional-style swivel accent chair will provide your space with a fresh and pleasing look. It's a great addition to any room in your home.",
		backgroundImage: sliderChairSingle,
		imgAlt: "classic chair",
	},
	{
		title: "Leather Chair",
		description: "Make a statement in your living room, den, or office with this classic swivel armchair. Crafted with an engineered wood frame, this chair has faux leather upholstery over pocketed seat springs and a high-density foam cushion.",
		backgroundImage: sliderChairLeather,
		imgAlt: "leather chair",
	},
	{
		title: "Double Leather Chair",
		description: "This recliner is a sleek addition to your living room. Crafted with a solid wood frame and metal legs, it's upholstered in sleek faux leather upholstery with a solid hue.",
		backgroundImage: sliderChairDouble,
		imgAlt: "double chair",
	},
	{
		title: "Lights",
		description: "Lighting fixture is step-less dimming (cool white light - natural light - warm white light). With the remote control, you can adjust the brightness and color.",
		backgroundImage: sliderLight,
		imgAlt: "ligths",
	},
	{
		title: "Dining Table",
		description: "A modern design round table looks great to match a chair, and this dining table will be suitable for any contemporary dining space.",
		backgroundImage: sliderDiningTable,
		imgAlt: "dining table",
	},
	{
		title: "Hutch Desk",
		description: "A spacious work surface and plenty of storage capacity make this desk a perfect choice for your home office. ",
		backgroundImage: hutchDesk,
		imgAlt: "hutch desk",
	},
	{
		title: "Child Mirror",
		description: "With the clear mirror, this kids vanity table and stool set with cute patterns is a fun and functional addition to your child's bedroom or play area.",
		backgroundImage: sliderChildMirror,
		imgAlt: "child mirror",
	},
	{
		title: "Powder Room",
		description: "Vanity Art introducing the premium popular marble design bath vanity with sink. It is the perfect blend of functionality and style for your home. ",
		backgroundImage: sliderPowderRoom,
		imgAlt: "powder room",
	},
	{
		title: "Blue fabric chair",
		description: "This piece boasts an ergonomical and sturdy design. Featuring extra cushioned faux fabric seat, back, and armrest for ultimate comfort throughout your workday.",
		backgroundImage: sliderChairBlue,
		imgAlt: "blue chair",
	},
	{
		title: "Ninja Knife",
		description: "This piece boasts an ergonomical and sturdy design. Featuring extra cushioned faux fabric seat, back, and armrest for ultimate comfort throughout your workday.",
		backgroundImage: sliderNinjaKnife,
		imgAlt: "ninja knife",
	},
];
